import React from "react";

interface IWorkIconProps {
    size?: number;
    color?: string;
}

export const WorkIcon: React.FC<IWorkIconProps> = ({ size = 24, color = "#575757" }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_360_8224)">
                <g clipPath="url(#clip1_360_8224)">
                    <path
                        d="M32.1427 26.1965C32.1427 21.4605 34.0241 16.9185 37.373 13.5696C40.7218 10.2207 45.2639 8.33936 49.9999 8.33936C54.7359 8.33936 59.2779 10.2207 62.6268 13.5696C65.9756 16.9185 67.857 21.4605 67.857 26.1965M82.1427 26.1965H17.857C14.0682 26.1965 10.4346 27.7016 7.75548 30.3807C5.07639 33.0598 3.57129 36.6934 3.57129 40.4822V79.7679C3.57129 83.5567 5.07639 87.1904 7.75548 89.8694C10.4346 92.5485 14.0682 94.0536 17.857 94.0536H82.1427C85.9315 94.0536 89.5651 92.5485 92.2442 89.8694C94.9233 87.1904 96.4284 83.5567 96.4284 79.7679V40.4822C96.4284 36.6934 94.9233 33.0598 92.2442 30.3807C89.5651 27.7016 85.9315 26.1965 82.1427 26.1965Z"
                        stroke={color} strokeWidth="8" strokeLinecap="round" strokeLinejoin="round"/>
                    <circle cx="50" cy="59.75" r="10.25" fill={color}/>
                </g>
            </g>
            <defs>
                <clipPath id="clip0_360_8224">
                    <rect width="100" height="100" fill="white"/>
                </clipPath>
                <clipPath id="clip1_360_8224">
                    <rect width="100" height="100" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
};
